import React, { Component } from 'react';
import HowItWorksAccordian from '../../../../components/HowItWorksAccordian';
import { Helmet } from 'react-helmet';

class HowItWorks extends Component {
  render () {
    return (
      <main className='main'>
        <Helmet>
          <title>Courses - How it works</title>
        </Helmet>
        <div className='l-container'>
          <h1 className='u-text-center'>How does my course work?</h1>
          <HowItWorksAccordian />
        </div>
      </main>
    );
  }
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/views/Main/CourseInfo/HowItWorks/index.js